import { MutationTree } from 'vuex';

export default <MutationTree<example.state.ExampleState>>{};
